import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SignupBrandLogoComponent } from '../../components/shared/signup-brand-logo/signup-brand-logo.component';
import { LegalNotesComponent } from '../../components/shared/legal-notes/legal-notes.component';

@Component({
  selector: 'dt-auth-layout',
  imports: [RouterOutlet, SignupBrandLogoComponent, LegalNotesComponent],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthLayoutComponent {}
